import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-flexbox-grid/lib/index";

import Pagination from "components/Pagination";
import PreviewFileDialog from "./PreviewFileDialog";
import FAQModal from "./FAQModal";
import CastDistChartModal from "./CastDistChartModal";
import FilterCard from "./FilterCard";
import CastsResultCard from "./CastsResultCard";

const DownloadLayout = props => (
  <div>
    <PreviewFileDialog {...props} />
    <CastDistChartModal {...props} />
    <FAQModal {...props} />

    {/* Main page content */}
    {/* Filters Card */}
    <Row>
      <Col xs={12}>
        <FilterCard {...props} />
      </Col>
    </Row>

    {/* Browser Card */}
    <Row style={{ marginTop: "1rem" }}>
      <Col xs={12}>
        <CastsResultCard {...props} />
      </Col>
    </Row>

    <Pagination
      next={props.onNextPageClick}
      prev={props.onPrevPageClick}
      page={props.pageNumber}
      nextDisabled={
        props.pageNumber * props.itemsPerPage >= props.totalCastsWithFilters
      }
    />
  </div>
);

DownloadLayout.propTypes = {
  pageNumber: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  totalCastsWithFilters: PropTypes.number,
  onNextPageClick: PropTypes.func.isRequired,
  onPrevPageClick: PropTypes.func.isRequired
};

DownloadLayout.defaultProps = {
  totalCastsWithFilters: 0
};

export default DownloadLayout;
